const banksName = [
    'مصرف الانماء',
    'البنك الأهلي التجاري',
    'بنك الرياض',
    'بنك البلاد',
    'مصرف الراجحي',
    'بنك الجزيرة',
    'البنك السعودي للاستثمار',
    'سامبا المالية',
    'البنك السعودي البريطاني',
    'البنك السعودي الهولندي',
    'البنك السعودي الفرنسي',
    'البنك العربي الوطني',
  ]
  export default banksName